import { ControlType, Property, PropertyType } from "../../../base/types";

import { DesignerMode } from "../../types";
import { FC } from "react";
import { IControlAttributes } from "../../../base/models";
import { Registry } from "../../../base/register";
import { useGetProperties } from "../../../base/hooks";

export const SectionComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { properties } = useGetProperties({ bindings: control.bindings });
    const hidden: boolean | undefined = properties[Property.Hidden]
    const title: string | undefined = properties[Property.Tooltip] || undefined;

    if (designerMode === DesignerMode.View && hidden === true) {
        return <></>
    }

    return (
        <div className={className} title={title}>
            {children}
        </div>)
}

Registry.addControl({
    id: "e564934c-471d-42aa-abba-c22fb0d12475",
    name: "Section",
    type: ControlType.Section,
    properties: [
        { id: Property.Hidden, name: 'Hidden', type: PropertyType.Boolean },
        { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String }
    ],
    component: SectionComponent
})
